import EnvelopeIcon from '@/components/icons/envelope';
import CheckDoubleIcon from '@/components/icons/check-double';
import SupportIcon from '@/components/icons/support';
import CheckIcon from '@/components/icons/check';

export const SALE_OFFER_DOCUMENT_SLUG = 'dogovor-oferta-s-avtorami';
export const SALE_OFFER_PDF_LINK_TEXT = 'Договора-оферты';

export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'Это поле обязательно',
  INVALID_URL: 'Введите корректную ссылку',
  INVALID_BIK: 'БИК должен содержать 9 цифр',
  INVALID_INN: 'ИНН должен содержать 12 цифр',
  INVALID_BANK_ACCOUNT: 'Номер счёта должен содержать 20 цифр',
  INVALID_DATE: 'Введите дату в формате дд/мм/гг или дд/мм/гггг',
  CONSENT_REQUIRED: 'Для подключения необходимо дать согласие',
} as const;

export const ENTITY_TYPES = [
  //ToDo: For now only individual is available
  { value: 'individual', label: 'Физическое лицо' },
  // { value: 'self_employed', label: 'Самозанятый' },
  // { value: 'sole_proprietor', label: 'ИП' },
] as const;

export const CITIZENSHIP_OPTIONS = [
  //ToDo: For now only RU is available
  { value: 'RU', label: 'РФ' },
  // { value: 'BY', label: 'Беларусь' },
  // { value: 'KZ', label: 'Казахстан' },
] as const;

export const BENEFITS = [
  {
    icon: <EnvelopeIcon className="w-3.5 h-3.5 text-[#000000]" />,
    label: 'Комиссия платформы',
    text: 'от 5% до 30%',
  },
  {
    icon: <CheckIcon className="w-3.5 h-3.5 text-[#000000]" />,
    label: 'Прозрачные условия:',
    text: 'полная отчетность по продажам в ЛК',
  },
  {
    icon: <CheckDoubleIcon className="w-3.5 h-3.5 text-[#000000]" />,
    label: 'Быстрый старт:',
    text: 'работаем с физ. лицами',
  },
  {
    icon: <SupportIcon className="w-3.5 h-3.5 text-[#000000]" />,
    label: 'Поддержка вашего роста:',
    text: 'сотрудничаем с топовыми издательствами',
  },
] as const;
